import React from 'react';

const MobileCatShevron = (props) => {
	return (
		<svg width="8" height="6" viewBox="0 0 8 6" fill="none" {...props}>
			<path
				d="M7.95825 1.56246L7.31242 0.916626L3.99992 4.22913L0.687418 0.916626L0.0415854 1.56246L3.99992 5.49996L7.95825 1.56246Z"
				fill="#1170FF"
			/>
		</svg>
	);
};

export default MobileCatShevron;
